




























import { defineComponent } from "@vue/composition-api";
import { Currency, InputCurrencyCreate } from "@teacherskaya/api-provider/dist/api/CurrencyProvider";
import { $t } from "@/lib/helpers/i18nHelper";
import { currencyList } from "@/lib/helpers/money";
import { FormFields, FormValues, ListFields } from "@/types";
import BlockBase from "@/components/BlockBase.vue";
import BlockBaseForm from "@/components/BlockBaseForm.vue";

export default defineComponent({
  name: "BlockCurrencyAdd",
  components: { BlockBaseForm, BlockBase },
  props: {
    currencyList: { type: Array as () => Currency[], required: true },
  },
  data() {
    return {
      valid: true,
    };
  },
  computed: {
    fields(): FormFields {
      return [
        {
          name: "name",
          title: $t("Currency"),
          type: "autocomplete",
          list: currencyList.reduce((out, item) => {
            out.push({ ...item, disabled: !!this.currencyList.find(i => i.name === item.value) });
            return out;
          }, [] as ListFields),
        },
        {
          name: "rate",
          title: $t("Rate per 1.00 {0}", [$t("credit")]),
          validateOnBlur: true,
          rules: [
            v => (v !== "" && !isNaN(Number(v))) || $t("{0} is required", [$t("Rate")]),
            v => Number(v) > 0 || $t("{0} should be greater than zero", [$t("Rate")]),
          ],
        },
      ];
    },
  },
  methods: {
    save(values: FormValues, vm: any) {
      if (!this.valid) return;
      const data: InputCurrencyCreate = {
        name: values.name,
        rate: Number(values.rate),
      };
      this.$emit("create", data, vm);
    },
    cancel() {
      this.$emit("cancel");
    },
  },
});
